import { yupResolver } from '@hookform/resolvers/yup';
import Box from '@mui/material/Box';
import Button from '@mui/material/Button';
import TextField from '@mui/material/TextField';
import Typography from '@mui/material/Typography';
import { useTranslation } from 'react-i18next';
import { useForm } from 'react-hook-form';
import * as yup from 'yup';

interface Props {
  handleSubmit: (email: string, lastName: string) => void;
  onCancel: () => void;
  isSubmitting?: boolean;
}

interface ClaimFormData {
  email: string;
  lastName: string;
}

const ClaimParticipantForm = ({ handleSubmit, onCancel, isSubmitting }: Props) => {
  const { t } = useTranslation();

  const claimSchema = yup.object().shape({
    email: yup.string().email().required(),
    lastName: yup.string().required(),
  });

  const {
    register,
    handleSubmit: onFormSubmit,
    formState: { errors },
    reset,
  } = useForm<ClaimFormData>({
    resolver: yupResolver(claimSchema),
    defaultValues: {
      email: '',
      lastName: '',
    },
  });

  const submit = (data: ClaimFormData) => {
    handleSubmit(data.email.trim(), data.lastName.trim());
    reset();
  };

  const handleCancel = () => {
    reset();
    onCancel();
  };

  return (
    <Box component="form" onSubmit={onFormSubmit(submit)} sx={{ mt: 1 }}>
      <Typography variant="body2" sx={{ mb: 3, color: 'text.secondary' }}>
        {t('participants.claim.description')}
      </Typography>

      <TextField
        {...register('email')}
        autoFocus
        margin="dense"
        label={t('participants.email')}
        type="email"
        fullWidth
        variant="outlined"
        error={!!errors.email}
        helperText={errors.email?.message}
        sx={{ mb: 2 }}
      />

      <TextField
        {...register('lastName')}
        margin="dense"
        label={t('form.lastName')}
        fullWidth
        variant="outlined"
        error={!!errors.lastName}
        helperText={errors.lastName?.message}
        sx={{ mb: 2 }}
      />

      <Box sx={{ display: 'flex', justifyContent: 'flex-end', gap: 1, mt: 3 }}>
        <Button onClick={handleCancel} color="inherit" disabled={isSubmitting}>
          {t('base.cancel')}
        </Button>
        <Button type="submit" variant="contained" color="primary" disabled={isSubmitting}>
          {t('participants.claim.submit')}
        </Button>
      </Box>
    </Box>
  );
};

export default ClaimParticipantForm;
